import React from "react";

import ContentWrapper from "../../common/ContentWrapper";
import BoxSkeleton from "./common/BoxSkeleton";
import CardSkeleton from "./common/CardSkeleton";
import DescSkeleton from "./common/DescSkeleton";
import DoubleInputSkeleton from "./common/DoubleInputSkeleton";
import InputSkeleton from "./common/InputSkeleton";
import PillSkeleton from "./common/PillSkeleton";
import ScrollSkeleton from "./common/ScrollSkeleton";
import SixBoxSkeleton from "./common/SixBoxSkeleton";
import SuggestionSkeleton from "./common/SuggestionSkeleton";
import TitleSkeleton from "./common/TitleSkeleton";
import { skeletonType } from "./config";

const Skeleton = ({
  screenType = "WORK_AUTH",
  isMobile,
}: {
  screenType: any;
  isMobile: boolean;
}) => {
  const getSkeleton = (type: string, props?: Record<string, any>) => {
    switch (type) {
      case "title":
        return <TitleSkeleton />;
      case "suggestions":
        return <SuggestionSkeleton />;
      case "input":
        return <InputSkeleton />;
      case "doubleInput":
        return <DoubleInputSkeleton />;
      case "desc":
        return <DescSkeleton />;
      case "sixBox":
        return <SixBoxSkeleton />;
      case "box":
        return <BoxSkeleton {...props} />;
      case "scroll":
        return <ScrollSkeleton />;
      case "card":
        return <CardSkeleton />;
      default:
        return <></>;
    }
  };

  return (
    <ContentWrapper className="gap-6">
      <div className="flex animate-pulse flex-col gap-6">
        {screenType &&
          skeletonType(isMobile)[screenType] &&
          skeletonType(isMobile)[screenType].map((v, i) => (
            <React.Fragment key={`skeleton-${i}`}>
              {v.type === "pills" ? (
                <PillSkeleton
                  key={`pills-${i}`}
                  length={v.quantity}
                  {...v.props}
                />
              ) : (
                Array.from({ length: v.quantity }).map((_, idx) => (
                  <React.Fragment key={`skeleton-${i}-${idx}`}>
                    {getSkeleton(v.type, v.props)}
                  </React.Fragment>
                ))
              )}
            </React.Fragment>
          ))}
      </div>
    </ContentWrapper>
  );
};

export default Skeleton;
